<div id="step5_reviewAndFinish" class="collapse" style="clear: both; display: none;">
		
	<!-- Title -->
	<h1 style="color:#f57300; font-size: 50px"><i class="fa fa-flag-checkered" aria-hidden="true"></i> 
		STEP 5: FINISH
	</h1>
	
	<!-- Instructions -->
	<div style="margin-top: 20px">
		Check the logic of the rule below by clicking VALIDATE RULE.
	</div>
	
	<!-- Validate Rule Button -->
	<button (click)="validateRuleClicked()" type="button" class="btn btn-ef">
		<i class="fa fa-check"></i>
		VALIDATE RULE
	</button>
	
	<hr />
	
	<!-- Validate Responses -->
	<div id="validateSuccess" style="display:none" class="alert alert-success">
		<strong>Success!</strong> The rule has been set up correctly.
	</div>
	<div id="validateWarning" style="display:none" class="alert alert-warning">
		<strong>Warning!</strong> There are things missing.
	</div>
	<div id="validateError" style="display:none" class="alert alert-danger">
		<strong>Danger!</strong> The rule is not logical.
		<span>
			{{mValidateErrorMessage}}
		</span>
	</div>
	
	<ng-container *ngIf="mIsRuleValidated">
		<hr />
		<div>Activate or deactivate this rule, then click FINISH.</div>
		<hr />
		<div class="radio radio-default radio-inline">
			<input type="radio" [(ngModel)]="mRule.isActive" [value]="true" />
			<label>ACTIVATE</label>
		</div>
		<div class="radio radio-default radio-inline">
			<input type="radio" [(ngModel)]="mRule.isActive" [value]="false" />
			<label>DEACTIVATE</label>
		</div>
		<hr />
		<button (click)="finishClicked()" type="button" class="btn btn-ef btn-lg btn-block"><i class="fa fa-check" aria-hidden="true"></i>FINISH</button>
	</ng-container>
	
</div>

<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>